module.exports = __webpack_public_path__ + "img/22-23EI.622ed1f6.png";